const ScrollToElementId = (id: string) => {
  try {
    const container: any = document.getElementById(id);
    container.scrollIntoView({ behavior: "smooth" });
  } catch (error) {}
};

export { ScrollToElementId };
